import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddOpsManager from "./addOpsManager";
import { getAllSuperviors, delelteSupervisor } from "../../redux/actions/supervisor";
import { Table, Button } from "antd";
import CustomModal from "../../common/CustomModal";

function AllOpsManager({ role }) {
  const dispatch = useDispatch();
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const supervisors = useSelector((state) => state.supervisor?.data);
  const isLoading = useSelector((state) => state.supervisor?.isProcessing);

  const roleLabelMap = {
    OPERATION_MANAGER: "Ops Manager",
    CLUSTER_LEADER: "Cluster Leader",
  };
  const roleLabel = roleLabelMap[role] || "User";

  useEffect(() => {
    dispatch(getAllSuperviors());
  }, [dispatch]);

  const handleDelete = (id) => {
    dispatch(delelteSupervisor(id)).then(() => {
      dispatch(getAllSuperviors());
    });
  };

  const handleEdit = (record) => {
    setSelectedUser(record);
    setModalVisible(true);
  };

  const columns = useMemo(() => {
    const commonColumns = [
      // {
      //   title: "ID",
      //   dataIndex: "supervisorId",
      //   key: "supervisorId",
      // },
      {
        title: "Email",
        dataIndex: "username",
        key: "username",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "phonenumber",
        key: "phonenumber",
      },
    ];

    const roleBasedColumn =
      role === "CLUSTER_LEADER"
        ? {
          title: "District(s)",
          dataIndex: "districts",
          key: "districts",
          render: (districts) =>
            Array.isArray(districts)
              ? districts.map((d) => d.districtName).join(", ")
              : "-",
        }
        : {
          title: "Zone / Tenant",
          key: "zoneOrTenant",
          render: (_, record) => record.tenant?.name || record.zone?.name || "-"
        };

    const actionColumn = {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Button type="primary" onClick={() => handleEdit(record)} style={{ marginRight: 8 }}>
            Edit
          </Button>
          <Button type="primary" danger onClick={() => handleDelete(record.supervisorId)}>
            Delete
          </Button>
        </>
      ),
    };

    return [...commonColumns, roleBasedColumn, actionColumn];
  }, [role]);


  // Filter supervisors based on the role received
  const filteredSupervisors = useMemo(() => {
    return supervisors?.filter((user) => user.role === role) || [];
  }, [supervisors, role]);

  return (
    <div>
      <h1>List of {roleLabel}s</h1>
      {isLoading ? <p>Loading...</p> : null}
      {filteredSupervisors.length > 0 ? (
        <Table
          dataSource={filteredSupervisors.map(user => ({ ...user, key: user?.supervisorId }))}
          columns={columns}
          rowKey="supervisorId"
        />
      ) : (
        <p>No {roleLabel}s Found</p>
      )}
      {isModalVisible && (
        <CustomModal
          visible={isModalVisible}
          onClose={() => setModalVisible(false)}
          title={`Edit ${roleLabel}`}
          content={
            <AddOpsManager
              currentUserDetails={selectedUser}
              onClose={() => setModalVisible(false)}
              role={role}
              isEdit={true}
            />
          }
        />
      )}
    </div>
  );
}

export default AllOpsManager;
